var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferralTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#65CBE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3571 14.0462L15.7742 23.3738C15.7119 23.4399 15.6383 23.4951 15.5647 23.5447C15.3381 23.6935 15.0776 23.7652 14.8171 23.7652C14.5565 23.7652 14.296 23.6935 14.0695 23.5447C13.9902 23.4951 13.9222 23.4399 13.8542 23.3738L8.18493 17.8555C8.14528 17.8169 8.10564 17.7783 8.07732 17.7342C7.65821 17.216 7.69785 16.4608 8.18493 15.9812C8.71731 15.463 9.57818 15.463 10.1106 15.9812L14.8227 20.5623L23.4371 12.1719C23.9695 11.6537 24.8304 11.6537 25.3628 12.1719C25.8951 12.6901 25.8951 13.528 25.3628 14.0462H25.3571Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralTick);
export default __webpack_public_path__ + "static/media/referral-tick.ff97cfd338b9f522eb7d114f5700f63e.svg";
export { ForwardRef as ReactComponent };